// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"177":"234bd2f1","198":"34b4573d","305":"648aea07","323":"1b5009e2","350":"eb453648","352":"39c226a9","779":"7fd4a861","870":"bff2b2ce","910":"c7945396"}[chunkId] + ".chunk.js";
};